export enum PreferenceKey {
  LOCALIZATION = 'localization',
  VERSION = 'version',
  RECENTLY_USED_EMOJIS = 'recentlyUsedEmojis',
  CURRENT_TIME_ZONE = 'currentTimeZone',
  FAVORITE_REACTIONS = 'favoriteReactions',
  USE_SOUND_NOTIFICATION = 'isUseSoundNotifications',
  IS_HIDDEN_NOTIFICATIONS = 'isHiddenNotifications',
  CALL_STATUS_DO_NOT_DISTURB = 'callStatusDoNotDisturb',
  DND_AUTO_ACTIVATE = 'isDndAutoActivate',
  DONT_DITURB_GROUPS = 'dontDisturbGroups',
  PUSH_TO_TALK_P2P = 'pushToTalkP2P',
  PUSH_TO_TALK_GROUP = 'pushToTalkGroup',
  INCOMING_CALL_URI = 'incomingCallUri',
  // @todo: remove this after migration
  VISIBLE_CONTACT_GROUPS = 'visibleContactGroups',
  HIDDEN_CONTACT_GROUPS = 'hiddenContactGroups',
  MIC_DISABLED_ON_START_CONFERENCE_GROUP = 'micDisabledOnStartConferenceGroup',
  CUSTOM_TEXT_REACTIONS = 'customTextReactions',
  OUTGOING_CALLS_HANDLING_CONDITION = 'outgoingCallsHandlingCondition',
  DEFAULT_TERMINAL_ID = 'defaultTerminalId',
  FAVORITE_FAST_REACTION = 'favoriteFastReaction',
  CHAT_FOLDERS = 'chatFolders',
}

export const PREFERENCES_VERSION = 10

export const allowedKeys = Object.values(PreferenceKey)
